import React, {useEffect, useContext} from 'react';
import {Form, Input, InputNumber, Button, Checkbox} from 'antd';
import {UserContext} from '../../../context/UserContext';

const CreateModalContent = ({data, setOpen, createCallback}) => {
	const [form] = Form.useForm();

	const onFinish = (values) => {
		let meta;
		try{
			meta = JSON.parse(values.metadata)
		}
		catch {
			meta = {}
		}
		values.metadata = meta;
		console.log({values});
	  createCallback(values);
	  setOpen(false);
	  form.resetFields();
	};
	const onFinishFailed = (errorInfo) => {
	  console.log('Failed:', errorInfo);
	};

	return (
		<div className='flex justify-center '>
			<Form id='createSiteForm' form={form} className='max-w-[80%]' onFinish={onFinish}
				    onFinishFailed={onFinishFailed}>
				<Form.Item className='mr-2' name='name' label="Name"
					rules={[
	                {
	                  	required: true,
	                  	message: 'name required',
	                },
              	]}
              	>
		        	<Input placeholder="Name" />
		      	</Form.Item>
		      	<Form.Item className='mr-2' name='display_name' label="Display Name"
					rules={[
	                {
	                  	required: true,
	                  	message: 'name required',
	                },
              	]}
              	>
		        	<Input placeholder="Display Name" />
		      	</Form.Item>
		      	<Form.Item className='mr-2' name='icon' label="Icon"
				rules={[
	                {
	                  	required: true,
	                  	message: 'icon required',
	                },
              	]}
              	>
		        	<Input placeholder="Icon" />
		      	</Form.Item>
		      	<Form.Item className='mr-2' name='metadata' label="Metadata"
					rules={[
		                {
		                  	required: true,
		                  	message: 'metadata required',
		                },
	              	]}
	              	>
		        		<Input.TextArea/>
		      	</Form.Item>
		      	<Form.Item className='mr-2' name='is_active' valuePropName="checked" label="Active"
	              	>
		        	<Checkbox />
		      	</Form.Item>
		      	<Form.Item>
			        <Button type="primary" htmlType="submit">Submit</Button>
		      	</Form.Item>
			</Form>
		</div>
	)
}

export default CreateModalContent;